import {
  AlertCircleLine,
  ChartLine,
  CheckDouble,
  Handshake,
  MessageFrown,
  MessageHeart,
} from '@factorialco/f0-react/icons/app'

import i18n from 'modules/core/lib/i18n'

import type { BlankStatePromptTypes } from './index'

interface BlankStateButton {
  label: string
  icon: typeof ChartLine
  content: string
}

export const useBlankStateButtons = (
  employeeName: string,
  type: BlankStatePromptTypes = 'manager_to_employee'
): BlankStateButton[] => {
  const managerToEmployeeBlankStateButtons: BlankStateButton[] = [
    {
      label: i18n.t(
        'meetings.one_on_ones.chat_blank_state.manager_to_employee.current_goals_and_progress.label'
      ),
      icon: ChartLine,
      content: i18n.t(
        'meetings.one_on_ones.chat_blank_state.manager_to_employee.current_goals_and_progress.content',
        { name: employeeName }
      ),
    },
    {
      label: i18n.t(
        'meetings.one_on_ones.chat_blank_state.manager_to_employee.blockers_and_risks.label'
      ),
      icon: AlertCircleLine,
      content: i18n.t(
        'meetings.one_on_ones.chat_blank_state.manager_to_employee.blockers_and_risks.content',
        { name: employeeName }
      ),
    },
    {
      label: i18n.t(
        'meetings.one_on_ones.chat_blank_state.manager_to_employee.pending_tasks.label'
      ),
      icon: CheckDouble,
      content: i18n.t(
        'meetings.one_on_ones.chat_blank_state.manager_to_employee.pending_tasks.content',
        { name: employeeName }
      ),
    },
    {
      label: i18n.t(
        'meetings.one_on_ones.chat_blank_state.manager_to_employee.signs_of_burnout.label'
      ),
      icon: MessageHeart,
      content: i18n.t(
        'meetings.one_on_ones.chat_blank_state.manager_to_employee.signs_of_burnout.content',
        { name: employeeName }
      ),
    },
  ]

  const managerToTeamBlankStateButtons: BlankStateButton[] = [
    {
      label: i18n.t(
        'meetings.one_on_ones.chat_blank_state.manager_to_team.are_goals_aligned.label'
      ),
      icon: Handshake,
      content: i18n.t(
        'meetings.one_on_ones.chat_blank_state.manager_to_team.are_goals_aligned.content'
      ),
    },
    {
      label: i18n.t(
        'meetings.one_on_ones.chat_blank_state.manager_to_team.any_blockers_or_risks.label'
      ),
      icon: MessageFrown,
      content: i18n.t(
        'meetings.one_on_ones.chat_blank_state.manager_to_team.any_blockers_or_risks.content'
      ),
    },
    {
      label: i18n.t('meetings.one_on_ones.chat_blank_state.manager_to_team.whats_pending.label'),
      icon: CheckDouble,
      content: i18n.t(
        'meetings.one_on_ones.chat_blank_state.manager_to_team.whats_pending.content'
      ),
    },
    {
      label: i18n.t(
        'meetings.one_on_ones.chat_blank_state.manager_to_team.any_wins_to_celebrate.label'
      ),
      icon: MessageHeart,
      content: i18n.t(
        'meetings.one_on_ones.chat_blank_state.manager_to_team.any_wins_to_celebrate.content'
      ),
    },
  ]

  switch (type) {
    case 'manager_to_team':
      return managerToTeamBlankStateButtons
    case 'manager_to_employee':
    default:
      return managerToEmployeeBlankStateButtons
  }
}
